import { format, formatDistanceToNow } from 'date-fns';

export function getTimeFromNow(date: Date | string) {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
}

export function formatDateTime(date: Date | string): string {
  return `${format(date, 'EEEE, MMMM d, yyyy')} at ${format(date, 'HH:mm a')}`;
}
